export default "__VITE_ASSET__DSiHgcQf__"